export default "__VITE_ASSET__BjGR389u__"